<app-offcanvas-base [returnUrl]="returnUrl">
  <ng-container title>Manage Plan</ng-container>
  <ng-container body>
    @if (currentSubscription) {
      <p>Your Plan</p>
      <div class="card border-secondary border-2">
        <div class="card-body">
          <div class="row">
            <div class="col h4 text-secondary mb-0">
              <div id="currentSubTitle">{{ currentSubscription.package.name }}</div>
            </div>
            <div class="col-auto h4 mb-0">
              @if (isYearly()) {
                {{ currentSubscription.package.yearly_cost | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
              } @else {
                {{ currentSubscription.upcoming_amount | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
              }
            </div>
          </div>
          <hr />
          <div class="row gy-3 justify-content-between">
            <div class="col-auto">
              <div class="text-muted">Start date:</div>
              <div class="fw-bold">{{ currentSubscription.date_start | date: 'dd MMM yyyy' }}</div>
            </div>
            <div class="col-auto">
              <div class="text-muted">Next payment:</div>
              <div class="fw-bold">
                {{ currentSubscription.date_next_payment | date: 'dd MMM yyyy' | emptyIndicator }}
              </div>
            </div>
            <div class="col-auto">
              <div class="text-muted">Billed:</div>
              <div class="fw-bold">{{ currentSubscription.frequency }}</div>
            </div>
          </div>
          <!-- TEMP DISABLE -->
          <!--
          @if (currentSubscription.frequency === SubscriptionFrequency.MONTHLY) {
            <app-billing-switch
              class="mt-3 d-block"
              (frequencyChange)="handleFrequencyChange($event)"
              [frequency]="billingFrequency()"
            [package]="currentSubscription.package"></app-billing-switch>
          }
          -->
          <app-payment-method
            [paymentMethod]="paymentMethod()"
            [payfastToken]="payfastToken()"></app-payment-method>
        </div>
      </div>
      @if (isYearly()) {
        <div class="small text-muted mt-3">
          Your subscription will renew automatically every
          @if (isYearly()) {
            year.
          } @else {
            month.
          }
          You can cancel anytime.
        </div>
        <div class="d-flex justify-content-between mt-3 text-success">
          <div>You save</div>
          <div>
            {{ savings | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
          </div>
        </div>
        <hr />
        <div class="d-flex justify-content-between text-dark fw-bold">
          <div>Total due today</div>
          <div>{{ proRataAmount?.pro_rata | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}</div>
        </div>
      }
      <div class="row gy-3 offcanvas-buttons">
        <div class="col-12 col-sm-auto">
          <button
            class="btn btn-outline-dark me-md-2"
            (click)="openModal()">
            Cancel subscription
          </button>
        </div>
        <div class="col-12 col-sm-auto ms-sm-auto">
          <button
            class="btn btn-primary"
            id="upgradeBtn"
            [disabled]="isUpgradeBtnDisabled()"
            (click)="isYearly() ? onUpgradeConfirm() : onUpgradePackage()"
            type="button">
            Upgrade plan
          </button>
        </div>
      </div>
    }
  </ng-container>
</app-offcanvas-base>
